module.exports = __webpack_public_path__ + "img/belt.a4b7da00.png";